<template>
  <ProductPriceNew
    v-if="price"
    class="flex flex-1 flex-col md:flex-auto md:justify-center md:pl-0"
    :price="price"
    :applied-reductions="appliedReductions"
    :show-tax-info="showShippingCostAndTaxHints"
    :show-price-reduction-badge="hasSpecial"
    :show-price-reduction="isActiveSalePeriod"
    :show-shipping-cost-hint="
      showShippingCostAndTaxHints && !isThisAPremiumClubProduct
    "
    :style-modifier="priceStyleModifier"
    :show-more-details-button="showMoreDetailsButton"
    :product="product"
    type="whisper"
    is-pdp
    :show-discount-as-absolute-price="showDiscountAsAbsolutePrice"
    @click:more-details="$emit('click:more-details')"
  />
</template>

<script setup lang="ts">
import type { Product, Variant } from '@scayle/storefront-nuxt'
import { getPrice } from '@scayle/storefront-nuxt'
import type { HyphenatedOrderNumber } from '~/types/product'

import useGlobalConfig from '~/composables/useGlobalConfig'

import { isPremiumClubProduct, getLowestPrice } from '~/utils/product'

type ProductValueProps = {
  product: Product
  activeVariant: Variant | undefined
  pricePromotionKey: string | undefined
  productOrderNumber: HyphenatedOrderNumber
  productVariants: Variant[]
  isActiveSalePeriod: boolean
  showShippingCostAndTaxHints?: boolean
  showMoreDetailsButton?: boolean
  showDiscountAsAbsolutePrice?: boolean
}

const props = withDefaults(defineProps<ProductValueProps>(), {
  showMoreDetailsButton: false,
  showShippingCostAndTaxHints: true,
  showDiscountAsAbsolutePrice: false,
})

defineEmits(['click:more-details'])

const globalConfig = useGlobalConfig()

const price = computed(() => {
  return props.activeVariant
    ? getPrice(props.activeVariant)
    : getLowestPrice(props.productVariants || [])
})

const hasSpecial = computed(() =>
  Boolean(price.value?.appliedReductions.length),
)

const appliedReductions = computed(() => {
  // First check if price.value?.appliedReductions exists
  if (
    price.value?.appliedReductions &&
    price.value.appliedReductions.length > 0
  ) {
    return price.value.appliedReductions
  }
  // Fallback
  return []
})

const isThisAPremiumClubProduct = computed(() =>
  isPremiumClubProduct(props.product),
)

const priceStyleModifier = computed(
  () => globalConfig.config.value?.blackFridayLabels && 'blackFriday',
)
</script>
